<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" width="32px" height="32px">
    <defs>
      <filter id="a">
        <feColorMatrix in="SourceGraphic" values="0 0 0 0 0.847000 0 0 0 0 0.847000 0 0 0 0 0.847000 0 0 0 1.000000 0"/>
      </filter>
    </defs>
    <g filter="url(#a)" fill="none" fill-rule="evenodd">
      <path d="M9 13.2h3V23H9v-9.8zM14.6 9h2.8v14h-2.8V9zm5.6 8H23v6h-2.8v-6z" fill="#000" fill-rule="nonzero"/>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'BarChartIcon',
};
</script>
